/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Tab_MethodInputs */

const en_directory_agent_readiness_tab_method = /** @type {(inputs: Directory_Agent_Readiness_Tab_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Method & evidence`)
};

const zh_directory_agent_readiness_tab_method = /** @type {(inputs: Directory_Agent_Readiness_Tab_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`方法与证据`)
};

/**
* | output |
* | --- |
* | "Method & evidence" |
*
* @param {Directory_Agent_Readiness_Tab_MethodInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_tab_method = /** @type {((inputs?: Directory_Agent_Readiness_Tab_MethodInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Tab_MethodInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_tab_method(inputs)
	return zh_directory_agent_readiness_tab_method(inputs)
});
export { directory_agent_readiness_tab_method as "directory.agent_readiness.tab.method" }